import * as scoreboard from '../../utils/scoreboard';

angular.module('app.directives.schedule').directive('broadcastSelectScoreboardConnection', () => {
  return {
    restrict: 'E',
    scope: { vm: '=' },
    controller: function ($scope, $rootScope) {
      'ngInject';
      const { vm } = $scope;

      $scope.options = scoreboard.getUIConnections($rootScope.account);

      const selectizeConfigBase = {
        valueField: 'value',
        labelField: 'label',
        highlight: true,
        searchField: 'label',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option'),
          item: renderSelectizeOption('source-chooser--selected'),
        },
      };
      $scope.selectizeConfig = angular.extend(
        { placeholder: 'Select the Hardware Sending the Score Data...' },
        selectizeConfigBase
      );
    },
    template: `
      <div class="form-group">
        <label>Scoreboard Connection</label>
        <select selectize ng-model="vm.service.broadcast.scoreboard_configuration.connection" options="options" config="selectizeConfig"></select>
      </div>
      `,
  };
});

function renderSelectizeOption(wrapperCssClass) {
  return function (item, escape) {
    let html = `<div class="selectize-option ${wrapperCssClass}">`;
    html += `<div class="selectize-option__icon-wrapper">`;
    if (item.icon) {
      html += '<img class="selectize-option__icon" src="' + item.icon + '">';
    }
    html += `</div>`;
    html += `<div class="selectize-option__content">`;
    html += `<div class="selectize-option__label-wrapper">`;
    html += `<strong class="selectize-option__label">${item.label}</strong>`;
    if (item.is_new) {
      html += `<span class="selectize-option__label-indicator text-bx-green font-bold">(NEW)</span>`;
    }
    html += `</div>`;
    html += `<small class="selectize-option__description">${item.description}</small>`;
    html += `</div>`; // end .selectize-option__content
    html += `</div>`;
    return html;
  };
}



// WEBPACK FOOTER //
// ./app/directives/schedule/broadcast-select-scoreboard-connection.js